import React, { useState } from 'react';
import { useAuth } from '../services/authService';
import { Link } from 'react-router-dom';  
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
function Login2() {
  const navigate=useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login: authServiceLogin } = useAuth();
  let userRole = '';
  let userBranch = '';
  let employeeName='';
  let userName='';

  const handleLogin = (e) => {
    e.preventDefault();
  
    try {
      var SchoolManagementSystemApi = require('school_management_system_api');
      var api = new SchoolManagementSystemApi.AuthorizationApi();
      var body = new SchoolManagementSystemApi.LoginRequest();
      body.username = email;
      body.password = password;
      console.log(body);
      api.login(body, function (error, data, response) {
        if (error) {
          console.error('API Error:', error);
        } else {
          try {
            var responseBody = JSON.parse(response.text); // Assuming response.body is already in JSON format
            console.log(responseBody);
            console.log(responseBody.data.employeeRole);
            if (responseBody.message === 'Login Successful') {
              userRole = responseBody.data.employeeRole;
              userBranch = responseBody.data.employeeBranch;
              employeeName= responseBody.data.employeeName;
              userName= responseBody.data.employeeUsername;

              // Navigate immediately. The dashboard component mounts its own fetch;
              // the previous pre-nav students fetch was only used to set a
              // totalStudentCount that no consumer actually reads — it was recomputed
              // from each dashboard's own fetch.
              authServiceLogin({
                role: userRole,
                branch: userBranch,
                employeeName: employeeName,
                userName: userName,
              });
              navigate('/');
            }
            else {
              alert(responseBody.message);
            }
          } catch (parseError) {
            console.error('Error parsing response:', parseError);
          }
        }
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };
  

  

  return (
    <div>
      <Navbar/>
    <div className="hero min-h-screen bg-base-200 flex items-center justify-center">
      <div className="card shadow-md bg-base-100 p-6 w-96">
        <div className="center-absolute justify-center image-full">
          <img alt="logo" src="/9logo.webp" className="responsive-logo" />
        </div>
        <form onSubmit={(e) => handleLogin(e)} className="space-y-4">
          {/* ... (rest of the form) */}
          <div className="flex flex-col">
            <label className="text-sm mb-1 mt-3">Email</label>
            <input
              type="email"
              placeholder="Email"
              className="input input-bordered"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm mb-1">Password</label>
            <input
              type="password"
              placeholder="Password"
              className="input input-bordered"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label className="text-s text-black cursor-pointer mt-1"><Link to='/ForgotPassword'>Forgot password?</Link></label>
          </div>
          <div className="flex justify-end">
            <button type="submit" className="btn btn-outline text-white" style={{ backgroundColor: '#2D5990' }}>
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
  );

}

export default Login2;
